import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DevExFormComponent } from '../../../devExtreme/src/devExForm/devExForm.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { FormStyle, IForm, ItemType, LabelLocation } from './abcForm';

@Component({
    selector: 'abcForm',
    template: '<ng-template #abcForm></ng-template>',
    standalone: false
})
export class AbcFormComponent implements OnInit, OnDestroy {
  @ViewChild('abcForm', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input() caption: string;
  @Input() id: string;
  @Input() itemType: ItemType;
  @Input() formData: any;

  private _width: string;
  private _height: string;
  private _visible: boolean;
  private _activeStateEnabled: boolean;
  private _alignItemLabels: boolean;
  private _disabled: boolean;
  private _hoverStateEnabled: boolean;
  private _labelLocation: LabelLocation;
  private _minColWidth: number;
  private _showOptionalMark: boolean;
  private _optionalMark: string;
  private _readOnly: boolean;
  private _requiredMark: string;
  private _requiredMessage: string;
  private _showRequiredMark: boolean;
  private _rtlEnabled: boolean;
  private _scrollingEnabled: boolean;
  private _showColonAfterLabel: boolean;
  private _showValidationSummary: boolean;
  private _tabIndex: number;
  private _class: string;

  @Input()
  get height() {
    return this._height;
  }
  set height(data) {
    if (this.componentRef) {
      this.componentRef.height = data;
    }
    this._height = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get activeStateEnabled() {
    return this._activeStateEnabled;
  }
  set activeStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.activeStateEnabled = data;
    }
    this._activeStateEnabled = data;
  }

  @Input()
  get alignItemLabels() {
    return this._alignItemLabels;
  }
  set alignItemLabels(data) {
    if (this.componentRef) {
      this.componentRef.alignItemLabels = data;
    }
    this._alignItemLabels = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }

  @Input()
  get labelLocation() {
    return this._labelLocation;
  }
  set labelLocation(data) {
    if (this.componentRef) {
      this.componentRef.labelLocation = data;
    }
    this._labelLocation = data;
  }

  @Input()
  get minColWidth() {
    return this._minColWidth;
  }
  set minColWidth(data) {
    if (this.componentRef) {
      this.componentRef.minColWidth = data;
    }
    this._minColWidth = data;
  }

  @Input()
  get showOptionalMark() {
    return this._showOptionalMark;
  }
  set showOptionalMark(data) {
    if (this.componentRef) {
      this.componentRef.showOptionalMark = data;
    }
    this._showOptionalMark = data;
  }

  @Input()
  get optionalMark() {
    return this._optionalMark;
  }
  set optionalMark(data) {
    if (this.componentRef) {
      this.componentRef.optionalMark = data;
    }
    this._optionalMark = data;
  }

  @Input()
  get readOnly() {
    return this._readOnly;
  }
  set readOnly(data) {
    if (this.componentRef) {
      this.componentRef.readOnly = data;
    }
    this._readOnly = data;
  }

  @Input()
  get requiredMark() {
    return this._requiredMark;
  }
  set requiredMark(data) {
    if (this.componentRef) {
      this.componentRef.requiredMark = data;
    }
    this._requiredMark = data;
  }

  @Input()
  get requiredMessage() {
    return this._requiredMessage;
  }
  set requiredMessage(data) {
    if (this.componentRef) {
      this.componentRef.requiredMessage = data;
    }
    this._requiredMessage = data;
  }

  @Input()
  get showRequiredMark() {
    return this._showRequiredMark;
  }
  set showRequiredMark(data) {
    if (this.componentRef) {
      this.componentRef.showRequiredMark = data;
    }
    this._showRequiredMark = data;
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }

  @Input()
  get showColonAfterLabel() {
    return this._showColonAfterLabel;
  }
  set showColonAfterLabel(data) {
    if (this.componentRef) {
      this.componentRef.showColonAfterLabel = data;
    }
    this._showColonAfterLabel = data;
  }

  @Input()
  get scrollingEnabled() {
    return this._scrollingEnabled;
  }
  set scrollingEnabled(data) {
    if (this.componentRef) {
      this.componentRef.scrollingEnabled = data;
    }
    this._scrollingEnabled = data;
  }

  @Input()
  get showValidationSummary() {
    return this._showValidationSummary;
  }
  set showValidationSummary(data) {
    if (this.componentRef) {
      this.componentRef.showValidationSummary = data;
    }
    this._showValidationSummary = data;
  }

  @Input()
  get tabIndex() {
    return this._tabIndex;
  }
  set tabIndex(data) {
    if (this.componentRef) {
      this.componentRef.tabIndex = data;
    }
    this._tabIndex = data;
  }

  public htmlAttributes: IForm;
  @Input() private style: ComponentStyle = ComponentStyle.DevExpress;
  private componentRef;

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
    this.rtlEnabled = abcComponentService.rtlEnabled;
  }

  ngOnInit(): void {
    this.setFormAttributesIfAvailable();
    this.createComponentInstance().subscribe(() => {});
  }

  ngOnDestroy(): void {}

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExFormComponent,
            this.viewContainerRef
          ).componentRef.instance;
          break;
        }
      }
       if (this.htmlAttributes.rtlEnabled) this.componentRef.rtlEnabled = this.htmlAttributes.rtlEnabled;
      if (this.htmlAttributes.id) this.componentRef.id = this.htmlAttributes.id;
      if (this.htmlAttributes.caption) this.componentRef.caption = this.htmlAttributes.caption;
      if (this.htmlAttributes.itemType) this.componentRef.itemType = this.htmlAttributes.itemType;
      if (this.htmlAttributes.formData) this.componentRef.formData = this.htmlAttributes.formData;
      if (this.htmlAttributes.visible) this.componentRef.visible = this.htmlAttributes.visible;
      if (this.htmlAttributes.activeStateEnabled)
        this.componentRef.activeStateEnabled = this.htmlAttributes.activeStateEnabled;
      if (this.htmlAttributes.alignItemLabels) this.componentRef.alignItemLabels = this.htmlAttributes.alignItemLabels;
      if (this.htmlAttributes.disabled) this.componentRef.disabled = this.htmlAttributes.disabled;
      if (this.htmlAttributes.hoverStateEnabled)
        this.componentRef.hoverStateEnabled = this.htmlAttributes.hoverStateEnabled;
      if (this.htmlAttributes.labelLocation) this.componentRef.labelLocation = this.htmlAttributes.labelLocation;
      if (this.htmlAttributes.minColWidth) this.componentRef.minColWidth = this.htmlAttributes.minColWidth;
      if (this.htmlAttributes.showOptionalMark)
        this.componentRef.showOptionalMark = this.htmlAttributes.showOptionalMark;
      if (this.htmlAttributes.optionalMark) this.componentRef.optionalMark = this.htmlAttributes.optionalMark;
      if (this.htmlAttributes.readOnly) this.componentRef.readOnly = this.htmlAttributes.readOnly;
      if (this.htmlAttributes.requiredMark) this.componentRef.requiredMark = this.htmlAttributes.requiredMark;
      if (this.htmlAttributes.requiredMessage) this.componentRef.requiredMessage = this.htmlAttributes.requiredMessage;
      if (this.htmlAttributes.showRequiredMark)
        this.componentRef.showRequiredMark = this.htmlAttributes.showRequiredMark;
      if (this.htmlAttributes.rtlEnabled) this.componentRef.rtlEnabled = this.htmlAttributes.rtlEnabled;
      if (this.htmlAttributes.scrollingEnabled)
        this.componentRef.vscrollingEnabledisible = this.htmlAttributes.scrollingEnabled;
      if (this.htmlAttributes.showColonAfterLabel)
        this.componentRef.showColonAfterLabel = this.htmlAttributes.showColonAfterLabel;
      if (this.htmlAttributes.showValidationSummary)
        this.componentRef.showValidationSummary = this.htmlAttributes.showValidationSummary;
      if (this.htmlAttributes.class) this.componentRef.class = this.htmlAttributes.class;
      if (this.htmlAttributes.tabIndex) this.componentRef.tabIndex = this.htmlAttributes.tabIndex;
      // this.componentRef.setFormStyle(this.htmlAttributes.setFormStyle());
      observer.next(this.componentRef);
    });

    return observable;
  }

  setFormAttributesIfAvailable() {
    if (this.id) {
      const style: FormStyle = {
        height: this.height,
        width: this.width,
      };
      this.htmlAttributes = {
        id: this.id,
        caption: this.caption,
        itemType: this.itemType,
        formData: this.formData,
        visible: this.visible,
        disabled: this.disabled,
        class: this.class,
        activeStateEnabled: this.activeStateEnabled,
        alignItemLabels: this.alignItemLabels,
        hoverStateEnabled: this.hoverStateEnabled,
        labelLocation: this.labelLocation,
        minColWidth: this.minColWidth,
        showOptionalMark: this.showOptionalMark,
        optionalMark: this.optionalMark,
        readOnly: this.readOnly,
        requiredMark: this.requiredMark,
        requiredMessage: this.requiredMessage,
        showRequiredMark: this.showRequiredMark,
        rtlEnabled: this.rtlEnabled,
        scrollingEnabled: this.scrollingEnabled,
        showColonAfterLabel: this.showColonAfterLabel,
        showValidationSummary: this.showValidationSummary,
        tabIndex: this.tabIndex,
        setFormStyle: (formStyle) => (formStyle = style),
      };
    }
  }
}
